module.exports = __webpack_public_path__ + "assets/img/20_431_big.f171b0cd.jpg";